import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listTimecards, listShifts, triggerTimecardSync } from '../api/client';
import type { ListTimecardsParams } from '../api/client';

export function useTimecards(params: ListTimecardsParams) {
  return useQuery({
    queryKey: ['timecards', params],
    queryFn: () => listTimecards(params),
    staleTime: 60_000,
  });
}

export function useShifts(params: ListTimecardsParams) {
  return useQuery({
    queryKey: ['shifts', params],
    queryFn: () => listShifts(params),
    staleTime: 60_000,
  });
}

export function useTriggerTimecardSync() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: triggerTimecardSync,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['timecards'] });
      void qc.invalidateQueries({ queryKey: ['shifts'] });
    },
  });
}
